import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { ContentPropType } from '../common/types';

import Spinner from '../common/Spinner';
import Markdown from '../common/Markdown';

class Contents extends Component {
  static propTypes = {
    locale: PropTypes.string.isRequired,
    contents: PropTypes.arrayOf(ContentPropType).isRequired,
    loading: PropTypes.bool.isRequired,
  };

  render() {
    const { locale, contents, loading } = this.props;

    if (loading) {
      return (
        <div className="Home-contents">
          <hr className="mt-2 mb-5" />

          <Spinner center />
        </div>
      );
    }

    return (
      <div id="contents" className="Home-contents">
        <hr className="mt-2 mb-5" />

        <div className="row">
          {contents.map(c => (
            <div key={c.id} className="col-sm-6 markdown mb-3">
              <Markdown source={c.body[locale]} />
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default Contents;
